import React, {useEffect, useState} from "react"

import {
  ChevronUp16
} from "@carbon/icons-react"

const ScrollUpButton = () => {
  const [isVisible, setIsVisible] = useState(false)

  const handleScrollUp = (e) => {
    if (window !== undefined) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }

  const triggerVisibility = (scrollDistance) => {
    setIsVisible(scrollDistance > 200)
  }

  useEffect(() => {
    triggerVisibility(window.scrollY)
    const handleScroll = event => {
      triggerVisibility(window.scrollY)
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, [])

  return (
    <button onClick={(e) => { handleScrollUp(e) }} className={`scroll-up-button ${isVisible ? "visible " : "invisible "}fixed bottom-4 right-4 bg-primary z-40`}>
      <ChevronUp16 className="h-8 w-8 text-white" />
    </button>
  )
}

export default ScrollUpButton
